import { Box, useMediaQuery, useTheme } from "@mui/material";
import AdvancedReportDataProvider from "./AdvancedReportDataProvider";
import AdvancedReportHeader from "./AdvancedReportHeader";
import AdvancedReportProvider from "./AdvancedReportProvider";
import AdvancedReportChart from "./components/AdvancedReportChart";
import AdvancedReportFilter from "./components/AdvancedReportFilter";
import AdvancedReportPivotTable from "./components/AdvancedReportPivotTable";
import AdvancedReportToolbar from "./components/AdvancedReportToolbar";
import {
  AdvancedReportFilterType,
  AdvancedReportValueType,
} from "./useAdvancedReport";

export interface AdvancedReportProps {
  title?: string;
  visibleValues?: AdvancedReportValueType[];
  visibleFilters?: AdvancedReportFilterType[];
}

const AdvancedReport: React.FC<AdvancedReportProps> = ({
  visibleValues,
  visibleFilters,
  title,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <AdvancedReportDataProvider
      visibleValues={visibleValues}
      visibleFilters={visibleFilters}
    >
      <AdvancedReportHeader title={title} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          ml: isMobile ? -3 : 0,
          mr: isMobile ? -3 : 0,
          "& .MuiPaper-root": {
            borderRadius: isMobile ? 0 : undefined,
          },
        }}
      >
        <AdvancedReportProvider>
          <AdvancedReportFilter />
          <AdvancedReportToolbar />
          <AdvancedReportChart />
          <AdvancedReportPivotTable />
        </AdvancedReportProvider>
      </Box>
    </AdvancedReportDataProvider>
  );
};
export default AdvancedReport;
